<template>
    <div>
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        </el-breadcrumb> -->
        <!-- <ProductTab :index="0" :type="2"></ProductTab> -->
        <!-- <OrderTab :index="index" @tap="tapFn"></OrderTab> -->
        <template v-if="index === 0">
          <el-card>
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">订单管理</span>
              </el-col>
              <el-col :span="12" align="right">
                <el-button type="text" style="color: #1f30c7;" @click="nextPage">查看全部订单>></el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) in menuList" :key="index">
                <div class="card2" @click="handleToDetail(item)">
                  <div class="circle"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                  <div class="card2-icon">
                    <i class="icon iconfont" :class="item.icon"></i>
                  </div>
                  <div class="card2-title">{{ item.title }}</div>
                  <div class="icons">
                    <img class="ico" v-for="(icon, j) in item.icons" :key="j" :src="icon" alt="">
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 15px">
            <el-row class="title_row">
              <el-col>
                <span class="title_class">订单总览</span>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="4" v-for="(item, i) of processedList" v-bind:key="i">
                <gameTransactionBackview :itemData="item" :key="i" @itemClicked="handleToolToDetail"></gameTransactionBackview>
              </el-col>
            </el-row>
          </el-card>
          <el-card style="margin-top: 15px">
            <el-row class="title_row">
              <el-col>
                <span class="title_class">快捷工具</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" v-for="(item,index) in toolList" :key="item.id" align="center">
                <div @click="handleToDetail(item)">
                  <div class="tool-item-icon" :class="'coloricon-reverse'+(index+1)"><i class="icon iconfont" :class="item.icon"></i></div>
                  <div class="tool-item-title">{{ item.title }}</div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </template>
        <!-- <el-row :gutter="16">
          <el-col :span="12">
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">商品总览</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="6"
                  v-for="(item, i) of goodsList"
                  v-bind:key="i"
                >
                  <div class="processed-list-back">
                    <div class="dataStatistics-desc">{{ item.number }}</div>
                    <div class="dataStatistics-title">{{ item.title }}</div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">用户总览</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="6"
                  v-for="(item, i) of userList"
                  v-bind:key="i"
                >
                  <div class="processed-list-back">
                    <div class="dataStatistics-desc">{{ item.number }}</div>
                    <div class="dataStatistics-title">{{ item.title }}</div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row> -->
        <!-- <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">营销工具</span>
            </el-col>
          </el-row>
          <div class="tool-con">
            <div class="tool-item" v-for="(item,index) in toolList" :key="item.id">
              <div class="tool-item-icon" :class="'coloricon-reverse'+(index+1)"><i class="icon iconfont" :class="item.icon"></i></div>
              <div class="tool-item-title">{{ item.title }}</div>
            </div>
          </div>
        </el-card> -->
        <!-- <OfflineOrder v-if="index === 1"></OfflineOrder> -->
    </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'
import { indexStatistics } from '@/http/api'
// import OrderTab from '../../../components/order_tab_component.vue'
// import OfflineOrder from './order/offline_order.vue'

export default {
  // components: {
  //   OrderTab, OfflineOrder
  // },
  data () {
    return {
      index: 0,
      menuList: [
        {
          id: 1,
          title: '赛事产品',
          icon: 'icon-chanpin',
          path: '/product_Management/product_management',
          flag: 'product_management',
          type: 'match',
          icons: [
            'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png',
            'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon7.png'
          ]
        },
        {
          id: 2,
          title: '营地产品',
          icon: 'icon-chanpin',
          path: '/product_Management/product_management',
          flag: 'product_management',
          type: 'camp',
          icons: [
            'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon8.png',
            'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon9.png',
            'https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon10.png'
          ]
        },
        {
          id: 3,
          title: '课程产品',
          icon: 'icon-chanpin',
          path: '/product_Management/product_management',
          flag: 'product_management',
          type: 'course'
        },
        {
          id: 4,
          title: '备赛产品',
          icon: 'icon-chanpin',
          path: '/product_Management/product_management',
          flag: 'product_management',
          type: 'prepare'
        }
        // {
        //   id: 2,
        //   title: '退费订单',
        //   icon: 'icon-tuihuo',
        //   path: '/product_Management/product_return_management',
        //   flag: 'product_return_management'
        // }
      ],
      dataList: [
        {
          id: 1,
          title: '订单管理',
          menuList: [
            {
              id: 1,
              title: '赛事产品订单',
              icon: 'icon-dingdandingdanmingxishouzhimingxi',
              path: '/product_Management/product_management',
              flag: 'product_management'
            },
            {
              id: 2,
              title: '营地产品订单',
              icon: 'icon-dingdandingdanmingxishouzhimingxi',
              path: '/product_Management/product_management',
              flag: 'product_management'
            },
            {
              id: 3,
              title: '课程产品订单',
              icon: 'icon-dingdandingdanmingxishouzhimingxi',
              path: '/product_Management/product_management',
              flag: 'product_management'
            },
            {
              id: 4,
              title: '备赛产品订单',
              icon: 'icon-dingdandingdanmingxishouzhimingxi',
              path: '/product_Management/product_management',
              flag: 'product_management'
            }
            // {
            //   id: 2,
            //   title: '退费订单',
            //   icon: 'icon-tuihuo',
            //   path: '/product_Management/product_return_management',
            //   flag: 'product_return_management'
            // }
          ]
        }
        // {
        //   id: 1,
        //   title: '产品管理',
        //   menuList: [
        //     {
        //       id: 1,
        //       title: '产品开通',
        //       icon: 'icon-gouwucheman',
        //       path: '/product_Management/launch_product_management',
        //       flag: 'launch_product_management'
        //     },
        //     {
        //       id: 2,
        //       title: '蜂计划管理',
        //       icon: 'icon-huihuajinglingicon-351',
        //       path: '/product_Management/product_planbee_management',
        //       flag: 'product_planbee_management'
        //     }
        //   ]
        // },
        // {
        //   id: 2,
        //   title: '优惠券码',
        //   menuList: [
        //     {
        //       flag: this.$chnEngStatusCode.productcoupon_management,
        //       id: 3,
        //       title: '优惠券管理',
        //       icon: 'icon-youhuiquan',
        //       path: '/product_Management/productcoupon_management'
        //     },
        //     {
        //       flag: this.$chnEngStatusCode.productcode_management,
        //       id: 3,
        //       title: '兑换码管理',
        //       icon: 'icon-chanpinbianma',
        //       path: '/product_Management/productcode_management'
        //     }
        //   ]
        // }
        // {
        //   id: 3,
        //   title: '课程管理',
        //   menuList: [
        //     {
        //       id: 1,
        //       title: '学校课程管理',
        //       icon: 'icon-house-full',
        //       path: '/product_Management/course_schoolorder_management'
        //     },
        //     {
        //       id: 2,
        //       title: '教师课程管理',
        //       icon: 'icon-jiaoshi',
        //       path: '/product_Management/course_teacherorder_management'
        //     }
        //   ]
        // }
      ],
      toolList1: [
        {
          id: 1,
          title: '优惠套餐',
          icon: 'icon-taocantuijian',
          path: ''
        },
        {
          id: 2,
          title: '满减',
          icon: 'icon-cuxiaoguanli',
          path: ''
        },
        {
          id: 3,
          title: '新客优惠券',
          icon: 'icon-quan',
          path: ''
        },
        {
          id: 4,
          title: '优惠券',
          icon: 'icon-youhuiquan',
          path: ''
        },
        {
          id: 5,
          title: 'N元任选',
          icon: 'icon-qiehuanmoshi',
          path: ''
        },
        {
          id: 6,
          title: '拼团购',
          icon: 'icon-tuangou',
          path: ''
        },
        {
          id: 7,
          title: '限时折扣',
          icon: 'icon-zhekou',
          path: ''
        },
        {
          id: 8,
          title: '秒杀管理',
          icon: 'icon-miaosha',
          path: ''
        },
        {
          id: 9,
          title: '新品推荐',
          icon: 'icon-xinpin1',
          path: ''
        }
      ],
      processedList: [
        {
          icon: 'icon-daifahuo',
          title: '待缴费订单',
          key: 'prepaidOrder',
          path: '/product_Management/product_management',
          status: '1',
          flag: 'product_management1',
          menuTag: '1',
          number: 0
        },
        // {
        //   icon: 'icon-fahuo2',
        //   title: '待发货订单',
        //   key: 'orderForDelivery',
        //   path: '/product_Management/product_management',
        //   status: '2',
        //   flag: 'product_management2',
        //   menuTag: '2',
        //   number: 0
        // },

        // {
        //   icon: 'icon-truck-completed_fill',
        //   title: '已发货订单',
        //   key: 'shippedOrder',
        //   path: '/product_Management/product_management',
        //   status: '3',
        //   flag: 'product_management3',
        //   menuTag: '3',
        //   number: 0
        // },
        // {
        //   icon: 'icon-gouwucheman',
        //   title: '待确认收货订单',
        //   key: 'returnOrderToBeConfirmed',
        //   path: '/product_Management/product_management',
        //   status: '11',
        //   flag: 'product_management11',
        //   menuTag: '6',
        //   number: 0
        // },
        {
          icon: 'icon-yiwancheng',
          title: '已完成订单',
          key: 'completedOrder',
          path: '/product_Management/product_management',
          status: '4',
          menuTag: '4',
          flag: 'product_management4',
          number: 0
        },
        {
          icon: 'icon-tuihuo',
          title: '待处理退款订单',
          key: 'pendingReturnOrder',
          path: '/product_Management/product_return_management',
          flag: 'product_return_management',
          menuTag: '5',
          number: 0
        },
        {
          icon: 'icon-xinpin1',
          title: '昨日新增支付订单',
          key: 'orderPaydNum',
          flag: 'product_yesterday',
          path: '/product_Management/product_management',
          menuTag: '2',
          type: '1',
          number: 0
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '订单问题反馈',
          key: 'newOutOfStockRegistration',
          path: '/product_Management/stock_registration_management',
          flag: 'stock_registration_management',
          menuTag: '7',
          number: 0
        }
        // {
        //   icon: 'icon-guanggaoguanli',
        //   title: '广告位即将到期',
        //   key: 'theAdSpaceIsAboutToExpire',
        //   menuTag: '8',
        //   number: 0
        // },
      ],
      goodsList: [
        {
          title: '虚拟商品',
          number: 0
        },
        {
          title: '实物商品',
          number: 0
        },
        {
          title: '已下架',
          number: 0
        },
        {
          title: '全部商品',
          number: 0
        }
      ],
      userList: [
        {
          title: '今日新增',
          number: 0
        },
        {
          title: '昨日新增',
          number: 0
        },
        {
          title: '本月新增',
          number: 0
        },
        {
          title: '会员总数',
          number: 0
        }
      ],
      toolList: [
        {
          id: 1,
          title: '退费订单',
          icon: 'icon-tuihuo',
          path: '/product_Management/product_return_management',
          flag: 'product_return_management'
        },
        {
          id: 2,
          title: '产品开通',
          icon: 'icon-gouwucheman',
          path: '/product_Management/launch_product_management',
          flag: 'launch_product_management'
        },
        // {
        //   id: 2,
        //   title: '蜂计划',
        //   icon: 'icon-huihuajinglingicon-351',
        //   path: '/product_Management/product_planbee_management',
        //   flag: 'product_planbee_management'
        // },
        {
          flag: this.$chnEngStatusCode.productcoupon_management,
          id: 3,
          title: '优惠券',
          icon: 'icon-youhuiquan',
          path: '/product_Management/productcoupon_management'
        },
        {
          flag: this.$chnEngStatusCode.productcode_management,
          id: 4,
          title: '兑换码',
          icon: 'icon-chanpinbianma',
          path: '/product_Management/productcode_management'
        }
      ]

    }
  },
  created () {
    this.getData()
    this.getProductTypeNum()
  },
  methods: {
    tapFn (index) {
      this.index = index
    },
    toolClicked (item) {
      if (!item.turnUrl) return
      this.$router.push(item.turnUrl)
    },
    //
    // 获取订单数
    getProductTypeNum () {
      indexStatistics({}).then((res) => {
        console.log('indexStatistics________', res)
        this.processedList.forEach(item => {
          if (item.flag === 'product_management1') {
            item.number = res.data.payNum
          } else if (item.flag === 'product_management4') {
            item.number = res.data.finishNum
          } else if (item.flag === 'product_return_management') {
            item.number = res.data.refundNum
          } else if (item.flag === 'stock_registration_management') {
            item.number = res.data.orderQuestionNum
          } else if (item.flag === 'product_yesterday') {
            item.number = res.data.orderPaydNum
          }
        })
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleToDetail (itemData) {
      if (this.hasPerms(itemData.flag)) {
        if (itemData.path) {
          this.$router.push(`${itemData.path}?type=${itemData.type}`)
        }
      } else {
        this.$message.warning('暂无操作权限')
      }
    },
    nextPage () {
      this.$router.push('/product_Management/product_management')
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    },
    handleToolToDetail ({ path, status, type }) {
      if (path) {
        // const query = status ? { status } : null
        const query = { status, type }
        this.$router.push({ path, query })
      }
    },
    getData () {
      // historicalProductStatistics({ activityType: this.$chnEngStatusCode.activityType }).then(res => {
      //   Object.keys(res.data).forEach(key => {
      //     this.processedList.find(item => item.key === key).number = res.data[key]
      //   })
      // })
    }
  }
}
</script>
<style scoped lang="less">
.product-card{
  height: 120px;
  color: #000;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  .product-card-title{
    height: 36px;
    line-height: 36px;
    padding-left: 20px;
    color: #fff;
    border-radius: 6px 6px 0 0;
    // background-color: rgba(255,255,255,.15);
  }
  .product-card-flex{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .product-card-item{
    flex: 1;
    text-align: center;
    height: 54px;
    margin-top: 15px;
    border-right: 1px solid rgba(0,0,0,.2);
    font-size: 14px;
    cursor: pointer;
    &:last-child{
      border-right: none;
    }
    .iconfont{
      font-size: 24px;
    }
  }
  .product-card-icon{
    margin-bottom: 4px;
  }
}
.product-card1{
  background-color: #E3F0FE;
  .product-card-title{
    background-color: #5EA6FD;
  }
  .iconfont, .card-title{
    color: #5EA6FD;
  }
}
.product-card2{
  background-color: #FDE8E6;
  .product-card-title{
    background-color: #FE887A;
  }
  .iconfont, .card-title{
    color: #FE887A;
  }
}
.product-card3{
  background-color: #e6fed5;
  .product-card-title{
    background-color: #6CCE27;
  }
  .iconfont, .card-title{
    color: #6CCE27;
  }
}

.tool-con{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tool-item{
    text-align: center;
  }
}
.tool-item-icon{
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 8px;
  .iconfont{
    font-size: 24px;
  }
}
.tool-item-title{
  color: #333;
  font-size: 14px;
}
.card2{
  background-color: rgba(64, 150, 255, .4);
  padding: 20px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 50px;
  .circle{
    background-color: rgba(255, 255, 255, .5);
    position: absolute;
    right: -20px;
    bottom: -20px;
    width: 80px;
    height: 80px;
    border-radius: 80px;
  }
  .circle2{
    background-color: rgba(255, 255, 255, .3);
    position: absolute;
    right: 40px;
    bottom: -10px;
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }
  .circle3{
    background-color: rgba(255, 255, 255, .4);
    position: absolute;
    top: 8px;
    left: 8px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
  }
  .card2-icon{
    .iconfont{
      font-size: 26px;
      color: #4096FF;
      margin-right: 6px;
    }
  }
  .card2-title{
    font-size: 16px;
    font-weight: bold;
    color: #4096FF;
  }
  .icons{
    position: relative;
    z-index: 100;
    margin-left: 14px;
    // bottom: 0;
    // left: 0;
    .ico{
      width: 30px;
      height: 30px;
      object-fit: contain;
      border-radius: 30px;
    }
  }
}
</style>
